import React from 'react';
import AsyncList from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import BlankLayout from '../../../../components/layout/BlankLayout';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/successstory/detail/:id?"
    element={<DefaultBusinessLayout />}
  >
    <Route
      path="business/successstory/detail/:id?"
      element={<AsyncList />}
    />
  </Route>,
  <Route
    key="/business/successstory/:storyHandle"
    element={<DefaultBusinessLayout />}
  >
    <Route path="business/successstory/:storyHandle" element={<AsyncList />} />
  </Route>,
  <Route
    key="/business/iframe/successstory/detail/:id?"
    element={<BlankLayout />}
  >
    <Route
      path="business/iframe/successstory/detail/:id?"
      element={<AsyncList />}
    />
  </Route>,
  <Route
    key="/business/iframe/successstory/:storyHandle"
    element={<BlankLayout />}
  >
    <Route
      path="business/iframe/successstory/:storyHandle"
      element={<AsyncList />}
    />
  </Route>,
];
